/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Representation of supplementary info, warning messages, even when the business APIs successfully execute their operations.
 * @export
 * @interface ApiMessage
 */
export interface ApiMessage {
    /**
     * Type of message, e.g. info, warning
     * @type {string}
     * @memberof ApiMessage
     */
    kind?: string;
    /**
     * A unique identifier for the message
     * @type {string}
     * @memberof ApiMessage
     */
    code?: string;
    /**
     * A human-readable description of the message
     * @type {string}
     * @memberof ApiMessage
     */
    message?: string;
    /**
     * Reference(s) to the specific part(s) of the cart that the message pertains to
     * @type {string}
     * @memberof ApiMessage
     */
    target?: string;
}

/**
 * Check if a given object implements the ApiMessage interface.
 */
export function instanceOfApiMessage(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ApiMessageFromJSON(json: any): ApiMessage {
    return ApiMessageFromJSONTyped(json, false);
}

export function ApiMessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiMessage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'kind': !exists(json, 'kind') ? undefined : json['kind'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'message': !exists(json, 'message') ? undefined : json['message'],
        'target': !exists(json, 'target') ? undefined : json['target'],
    };
}

export function ApiMessageToJSON(value?: ApiMessage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'kind': value.kind,
        'code': value.code,
        'message': value.message,
        'target': value.target,
    };
}

